module.exports = __webpack_public_path__ + "img/mupa-svg.756d4327.svg";